import { useTranslation } from '@/app/translations/translations-hooks'
import { getClassifications } from '@/modules/ecom-policy/new/helpers'

import ClassificationTile from './ClassificationTile'

import { useNewPolicyContext } from '../../index.context'

const StepType = () => {
  const translate = useTranslation()

  const classifications = getClassifications(translate)

  const [selectedClassifications, setSelectedClassifications] =
    useNewPolicyContext().selectedClassifications

  return (
    <div className="m-4 mb-8 grid gap-8 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {classifications.map(classificationsListItem => (
        <ClassificationTile
          key={classificationsListItem.symbol}
          symbol={classificationsListItem.symbol}
          label={classificationsListItem.label}
          selectedClassifications={selectedClassifications}
          setSelectedClassifications={setSelectedClassifications}
        />
      ))}
    </div>
  )
}

export default StepType
